import Constants from '../utils/consts';
import Cookies from 'universal-cookie';
import getCurrentConfigurazione from './getCurrentConfigurazione';
import translateString from '../utils/Locales';
import Utils from '../utils/utils';

var db = new Cookies().get('db', {path: '/' });
var http = require('follow-redirects').https;
var qs = require('querystring');
let t = translateString;

export default async function sendMail(username, token, from, fromName, to, toName, attachmentPath, subject, body) {
    
    let res = await getCurrentConfigurazione(username, token, db);
    if (res !== null && res.result === 'ok') {
        let isVerified = res.configurazioni.email_verified;
        if (isVerified !== '1') { 
            Utils.showError(t('email_n_verificata'));
            return null;
        } else {
            return new Promise(function (resolve, reject) {
                var options = {
                'method': 'POST',
                'hostname': Constants.ipAddress,
                'path': Constants.apisFolder + 'sendMail.php',
                'headers': {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
                },
                'maxRedirects': 20
                };
        
                var req = http.request(options, function (res) {
                var chunks = [];
        
                res.on("data", function (chunk) {
                    chunks.push(chunk);
                });
        
                res.on("end", function (chunk) {
                    var body = Buffer.concat(chunks);
                    resolve('OK');
                });
        
                res.on("error", function (error) {
                    console.error(error);
                });
                });
        
                var postData = qs.stringify({
                    'uname': username,
                    'token': token,
                    'from': from,
                    'fromName': fromName,
                    'to': to,
                    'cc': '',
                    'bcc': '',
                    'bcc2': '',
                    'toName': toName,
                    'attachmentPath': attachmentPath,
                    'subject': subject,
                    'body': body,
                    'db_name': db, 
                });
        
                req.write(postData);
        
                req.end();
        
                
            });
        }
    } else {
        Utils.showError(t('errore_imprevisto'));
        return null;
    }
}
